import React from 'react'
import { Table, Switch } from 'antd'
import { Vertical } from 'types/vertical'
import { useVerticalsQuery, useUpdateVerticalEnabled } from 'services/verticalsQueryService'
import styles from './Verticals.module.scss'
import { VERTICAL_ROUTE_MAP } from '../../config/verticalRoutes'
import icons from '../../components/Navigation/icons'

const Verticals: React.FC = () => {
  const { data: verticals = [], isLoading } = useVerticalsQuery()
  const { updateVertical, isPending } = useUpdateVerticalEnabled()

  const handleToggle = (id: string, isEnabled: boolean) => {
    updateVertical(id, isEnabled)
  }
  const hover = (title: string, mouseIn: boolean) => {
    if (mouseIn) {
      document.getElementById(`nav-${title}`)?.classList.add(styles.haloEffect)
    } else {
      document.getElementById(`nav-${title}`)?.classList.remove(styles.haloEffect)
    }
  }

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (name: string, record: Vertical) => {
        const overparticularElement = VERTICAL_ROUTE_MAP[record.id]
        let iconUrl
        if (overparticularElement) {
          iconUrl = (icons as Record<string, string>)[overparticularElement.iconKey]
        }

        return (
          <div
            onMouseEnter={() => hover(overparticularElement.title, true)}
            onMouseLeave={() => hover(overparticularElement.title, false)}
            className={styles.name}
          >
            {iconUrl && <img src={iconUrl} alt={record.name} className={styles.icon} />}
            <span>{name}</span>
          </div>
        )
      },
    },
    {
      title: 'Enabled',
      dataIndex: 'isEnabled',
      key: 'isEnabled',
      render: (isEnabled: boolean, record: Vertical) => (
        <Switch checked={isEnabled} onChange={checked => handleToggle(record.id, checked)} disabled={isPending} />
      ),
    },
  ]

  return (
    <div className={styles.container}>
      <Table dataSource={verticals} columns={columns} rowKey='id' pagination={false} loading={isLoading} />
    </div>
  )
}

export default Verticals
